export default "__VITE_ASSET__Bn5dMAJ3__"